import { Typography } from "@material-ui/core";
import Box from "@mui/material/Box";

const BankDetails = (props: any) => {
  const { ifscData } = props;

  return (
    <>
      <Box className="bank-details">
        <div className="row-one">
          <div>
            <Typography variant="h3">BRANCH NAME</Typography>
          </div>
        </div>
        <Typography variant="h6">{ifscData?.BRANCH}</Typography>
        <div className="row-one">
          <Typography className="title">IFSC</Typography>
          <Typography className="title-value">{ifscData?.IFSC}</Typography>
        </div>
        <div className="row-one">
          <Typography className="title">ADDRESS</Typography>
          <Typography className="title-value">{ifscData?.ADDRESS}</Typography>
        </div>
      </Box>
    </>
  );
};

export default BankDetails;
